import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { safeLocal } from "../lib/safeStorage";
import { STEALTH_KEY } from "../lib/storageKeys";
import { clearPostHogQueue } from "../lib/posthogAnalytics";

const StealthContext = createContext({
  stealth: false,
  setStealth: () => {},
});

export const StealthProvider = ({ children }) => {
  const [stealth, setStealthState] = useState(
    () => safeLocal.getItem(STEALTH_KEY) === "1",
  );

  useEffect(() => {
    safeLocal.setItem(STEALTH_KEY, stealth ? "1" : "0");
  }, [stealth]);

  const setStealth = useCallback((v) => {
    safeLocal.setItem(STEALTH_KEY, v ? "1" : "0");
    if (v) clearPostHogQueue();
    setStealthState(!!v);
  }, []);

  return (
    <StealthContext.Provider value={{ stealth, setStealth }}>
      {children}
    </StealthContext.Provider>
  );
};

export const useStealth = () => useContext(StealthContext);
